<template>
    <div class="div">
        <button class="button is-small" :class="{'bold' : isFilled }" @click="openModal" style="width: 55px;">
            {{ car.docs_send ? formatDate(car.docs_send) : '---' }}
        </button>
        <div class="modal" :class="{'is-active': isActive }">
            <div class="modal-background" @click="isActive = !isActive"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Currier & Tracking: {{ car.carrier }}</p>
                    <button class="delete" aria-label="close" @click="isActive = !isActive"></button>
                </header>
                <section class="modal-card-body">
                    <table class="is-fullwidth table is-bordered is-striped">
                        <thead>
                        <tr>
                            <th width="10">Select</th>
                            <th>Name</th>
                            <th>Info</th>
                            <th colspan="2">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(company, index) in companies">
                            <td width="10">
                                <button class="button is-info" @click="selectCompany(company.name, company.info)">
                                        <span class="icon">
                                          <i class="fas fa-check"></i>
                                        </span>
                                </button>
                            </td>
                            <td>
                                <input v-if="editCompany.id === company.id" class="input" v-model="editCompany.name " type="text" placeholder="Company name">
                                <span class="subtitle" v-else>{{ company.name }}</span>
                            </td>
                            <td>
                                <input v-if="editCompany.id === company.id" class="input" v-model="editCompany.info " type="text" placeholder="Tracking url">
                                <span v-else>{{ company.info }}</span>
                            </td>
                            <td width="10">
                                <button v-if="editCompany.id === company.id" class="button is-primary" @click="saveEditedCompany">
                                        <span class="icon">
                                          <i class="fas fa-save"></i>
                                        </span>
                                </button>
                                <button v-else class="button is-info" @click="selectEditCompany(company)">
                                        <span class="icon">
                                          <i class="fas fa-edit"></i>
                                        </span>
                                </button>
                            </td>
                            <td width="10">
                                <button class="button is-danger" @click="deleteCompany(index, company)">
                                        <span class="icon">
                                          <i class="fas fa-trash"></i>
                                        </span>
                                </button>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <input v-model="newCompany.name" class="input" type="text" placeholder="Type name of the company">
                            </td>
                            <td colspan="2">
                                <input v-model="newCompany.info" class="input" type="text" placeholder="Type company url">
                            </td>
                            <td width="10">
                                <button class="button is-primary" @click="createNewCompany">
                                    <span class="icon">
                                        <i class="fas fa-save"></i>
                                    </span>
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <div class="field is-horizontal">
                        <div class="field-body">
                            <div class="field">
                                <datetime
                                        input-class="input"
                                        v-model="carData.query.docs_send"
                                        :format="{ month: 'numeric', day: 'numeric'}"
                                        type="date"
                                        value-zone="local"
                                        zone="local"
                                        :input-id="carData.id.toString()"
                                        placeholder="Select date"
                                ></datetime>
                            </div>
                            <div class="field">
                                <input type="text" class="input" v-model="carData.query.post_tracking_number" placeholder="Type tracking number"/>
                            </div>
                        </div>
                    </div>
                    <div class="field is-horizontal">
                        <div class="field-body">
                            <div class="field">
                                <input type="text" class="input" v-model="carData.query.post_tracking_url" placeholder="Type tracking url"/>
                            </div>
                        </div>
                    </div>
                </section>
                <footer class="modal-card-foot">
                    <button class="button"  @click="isActive = !isActive">Close</button>
                    <button class="button is-primary"  @click="saveChanges" :disabled="isDisabled">Save</button>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
    import apiCars from './../../../api/apiCars'
    import apiCarrierCompanies from './../../../api/apiCarrierCompanies'
    import { Datetime } from 'vue-datetime'
    import 'vue-datetime/dist/vue-datetime.css'
    import moment from 'moment'
    export default {
        props:['car'],
        components: {
            Datetime
        },
        data () {
            return {
                isDisabled: false,
                isActive: false,
                companies: [],
                editCompany: {
                    id: null,
                    name: null,
                    info: null
                },
                carData:{
                    id: this.car.id,
                    query: {
                        docs_send: this.car.docs_send,
                        post_tracking_number: this.car.post_tracking_number,
                        post_tracking_url: this.car.post_tracking_url,
                        carrier: this.car.carrier,
                    }
                },
                newCompany: {
                    name: '',
                    info: ''
                }
            }
        },
        computed: {
            isFilled() {
                if (this.formatDate(this.carData.query.post_tracking_number) !== '---'){
                    return  true;
                }
            }
        },
        methods: {
            saveEditedCompany() {
                apiCarrierCompanies
                    .updateCarrierCompanyRequest(this.editCompany)
                    .then((response) => {
                        this.fetchCompanyList()
                        this.editCompany = {
                            id: null,
                            name: null,
                            info: null
                        }
                        this.isDisabled = false;
                    })
                    .catch(error => console.log(error))
            },
            selectEditCompany(comapny) {
                this.isDisabled = true
                this.editCompany = comapny
            },
            createNewCompany(){
                apiCarrierCompanies
                    .createCarrierCompanyRequest(this.newCompany)
                    .then((response) => {
                        this.companies.push(response.data)
                        this.newCompany.name = ''
                        this.newCompany.info = ''
                    })
                    .catch(error => console.log(error))
            },
            selectCompany(name, url) {
                this.carData.query.carrier = name
                this.carData.query.post_tracking_url = url
                apiCars
                    .updateCarRequest(this.carData)
                    .then((response) => {
                        this.car.carrier = this.carData.query.carrier
                        this.car.post_tracking_url = this.carData.query.post_tracking_url
                    })
                    .catch(error => console.log(error))
            },
            deleteCompany(index, port){
                apiCarrierCompanies
                    .deleteCarrierCompanyRequest(port.id)
                    .then((response) => {
                        this.companies = this.companies.filter(item => item !== port)
                    })
                    .catch(error => console.log(error))
            },
            formatDate(date) {

                if(date){
                    return moment(date).format('M/D')
                }else{
                    return '---'
                }
            },
            fetchCompanyList() {
                apiCarrierCompanies
                    .carrierCompaniesListRequest()
                    .then((response) => {
                        this.companies = response.data
                    })
                    .catch(error => console.log(error))
            },
            openModal() {
                this.isActive = !this.isActive
                this.fetchCompanyList()
            },
            saveChanges() {
                apiCars
                    .updateCarRequest(this.carData)
                    .then((response) => {
                        this.car.docs_send = this.carData.query.docs_send
                        this.car.post_tracking_number = this.carData.query.post_tracking_number
                        this.car.post_tracking_url = this.carData.query.post_tracking_url
                        this.car.carrier = this.carData.query.carrier
                        this.isActive = false
                    })
                    .catch(error => console.log(error))
            }

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Cars/Columns/DocsSendColumn.vue